import { ACTIONS } from '../../constants/constants';

const allPartnerShipDataReducer = function (state = [], action) {
  switch (action.type) {
    case ACTIONS.SET_ALL_PARTNERSHIP_DATA:
      return action.data;
    default:
      return state;
  }
};

export default allPartnerShipDataReducer;
